<template>
  <hm-col :id="$attrs['id']" :grid="true" cols="12">
    <guest-search v-if="search"
                  ref="guestSearch"
                  v-model="internalValue"
                  :disabled="disabled"
                  :label="isEmpty(label) ? $t('inputgroups.lineGuestProfileEditor.label') : label"
                  :help="help"
                  :type="type"
                  cols="12 6@tablet" />
    <hm-input v-model="profile.firstName"
              :disabled="!profile.unlocked || inputsDisabled"
              :label="$t('inputgroups.lineGuestProfileEditor.firstName')"
              :icons-right="profile.unlocked ? 0 : 1"
              name="firstName"
              cols="12 6@tablet 3@desktop"
              @blur="updateSearch()" >
      <template slot="icon-inline-right" slot-scope="slot">
        <input-icon-button v-tooltip="{ title: $t('inputgroups.guestProfileEditor.unlockGuestName'), delay: 0, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                           v-if="!profile.unlocked"
                           :border="true"
                           :disabled="inputsDisabled"
                           icon="unlock"
                           @click="profile.unlocked = true" />
      </template>
    </hm-input>
    <hm-input v-model="profile.lastName"
              :disabled="!profile.unlocked || inputsDisabled"
              :label="$t('inputgroups.lineGuestProfileEditor.lastName')"
              :icons-right="profile.unlocked ? 0 : 1"
              name="lastName"
              cols="12 6@tablet 3@desktop"
              @blur="updateSearch()" >
      <template slot="icon-inline-right" slot-scope="slot">
        <input-icon-button v-tooltip="{ title: $t('inputgroups.guestProfileEditor.unlockGuestName'), delay: 0, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                           v-if="!profile.unlocked"
                           :border="true"
                           :disabled="inputsDisabled"
                           icon="unlock"
                           @click="profile.unlocked = true" />
      </template>
    </hm-input>
  </hm-col>
</template>

<script>

import GridMixin from '@/mixins/GridMixin';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil, isEmpty, isEqual } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmTextarea from '../inputs/HmTextarea';
import GuestSearch from '../inputs/GuestSearch';

export default {
  name: 'LineProfileEditor',
  components: { GuestSearch, HmTextarea },
  mixins: [GridMixin, HotelmeisterMixin, SaveWatchMixin],

  props: {
    value: {
      required: true,
    },
    label: {
      required: false,
      default: null,
      type: String,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    search: {
      required: false,
      type: Boolean,
      default: true,
    },
    help: {
      required: false,
      type: String,
      default: null,
    },
  },

  autosave: [
    {
      name: 'profile',
      variable: 'profile',
      fn: function (cbSaveComplete) {
        if (!isEmpty(this.internalValue)) {
          this.axios.put(this.serviceUrls.guest.get(this, this.internalValue), this.profile)
            .then((response) => {
              cbSaveComplete();
              this.showMessages(response);
            })
            .catch((error) => {
              this.showMessages(error.response);
              cbSaveComplete();
            });
        } else if (!this.isEmptyProfile(this.profile)) {
          this.axios.post(this.serviceUrls.guest.get(this, ''), this.profile)
            .then((response) => {
              this.profile.id = response.data.data;
              this.internalValue = response.data.data;
              this.profile.unlocked = true;
              cbSaveComplete();
              this.showMessages(response);
            })
            .catch((error) => {
              this.showMessages(error.response);
              cbSaveComplete();
            });
        } else {
          cbSaveComplete();
        }
      },
    },
  ],

  data() {
    return {
      internalValue: this.value,
      type: 'Guest',
      profile: {
        type: this.type,
        primaryAddress: {},
        unlocked: true,
      },
    };
  },

  computed: {
    inputsDisabled: function () {
      return this.disabled || this.profile.deleted;
    },
  },

  watch: {
    value: function () {
      this.internalValue = this.value;
    },
    internalValue: function (newValue, oldValue) {
      this.$emit('input', this.internalValue);
      if (newValue === this.profile.id) return;

      if (isNil(newValue)) {
        this.profile = {
          type: this.type,
          primaryAddress: {},
          unlocked: true,
        };
      } else {
        const $vm = this;
        this.axios
          .get(this.serviceUrls.guest.get(this, newValue))
          .then((response) => {
            $vm.profile = {
              unlocked: false,
              ...response.data.data,
            };
          })
          .catch((error) => {
            $vm.profile = {
              type: $vm.type,
              primaryAddress: {},
              unlocked: true,
            };
          });
      }
    },
  },

  created: function () {
    if (isNil(this.internalValue)) {
      this.profile = {
        type: this.type,
        primaryAddress: {},
        unlocked: true,
      };
    } else {
      this.as__pauseAutosave('profile');
      const $vm = this;
      this.axios
        .get(this.serviceUrls.guest.get(this, this.internalValue))
        .then((response) => {
          $vm.profile = {
            unlocked: false,
            ...response.data.data,
          };
        })
        .catch((error) => {
          $vm.profile = {
            type: $vm.type,
            primaryAddress: {},
            unlocked: true,
          };
        })
        .finally(() => {
          this.as__continueAutosave('profile');
        });
    }
  },

  methods: {
    isEmpty: function (val) {
      return isEmpty(val);
    },
    isEmptyProfile: function (val) {
      if (!isEmpty(val.companyName)) return false;
      if (!isEmpty(val.namePrefix)) return false;
      if (!isEmpty(val.lastName)) return false;
      if (!isEmpty(val.firstName)) return false;
      if (!isEmpty(val.primaryEMailAddress)) return false;
      if (!isEmpty(val.primaryAddress.address)) return false;
      if (!isEmpty(val.primaryAddress.zipCode)) return false;
      if (!isEmpty(val.primaryAddress.city)) return false;
      if (!isEmpty(val.primaryAddress.country)) return false;
      return true;
    },
    updateSearch: function () {
      this.$refs.guestSearch.updateValue(null, true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/lib/inputgroups/LineGuestProfileEditor.vue